import * as yup from 'yup';

import { validatePassword } from '../validation/index';
import { setNewPasswordDataKeys } from '../constants';

const errorMessages = {
    newPassword: {
        min: 'supabase_password_min',
        required: 'supabase_password_required',
        invalid: 'supabase_password_invalid',
    },
    confirmNewPassword: {
        doesNotMatch: 'supabase_passwords_do_not_match_error',
    },
};

export const setNewPasswordDataSchema = yup.object({
    [setNewPasswordDataKeys.newPassword]: yup
        .string()
        .required(errorMessages.newPassword.required)
        .min(8, errorMessages.newPassword.min)
        .test('is-valid-password', errorMessages.newPassword.invalid, (value) =>
            validatePassword(value || '')
        ),
    [setNewPasswordDataKeys.confirmNewPassword]: yup
        .string()
        .required(errorMessages.newPassword.required)
        .oneOf([yup.ref('newPassword')], errorMessages.confirmNewPassword.doesNotMatch),
});
